module.exports = __webpack_public_path__ + "static/media/bootstrap-5-logo.6aae84ab.svg";